import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash';

class KeywordExamples extends React.Component{

    constructor(props){
      super(props);
    }

    render(){
      var {onClick, relatedSearches} = this.props;
      var examples;
      if(!_.isEmpty(relatedSearches)){
        examples = relatedSearches.slice(0, 3);
      } else{
        examples = ['gut health', 'credit score', 'seo content'];
      }

      return ReactDOM.createPortal(<div className="recommended-search-box">
        <div className="recommended-search-title">Examples:</div> {_.map(examples, (example, i) => {
          return (<span key={i}><a className="recommended-search-link" href="#" onClick={(e) => {onClick(example);}}>{example}</a>{i < examples.length-1 ? ', ' : ''}</span>)
        })}
      </div>, document.getElementById('keyword-examples'));
    }

}

export default KeywordExamples